import { render, staticRenderFns } from "./VideoListItem.vue?vue&type=template&id=735c16b4&scoped=true"
import script from "./VideoListItem.vue?vue&type=script&lang=js"
export * from "./VideoListItem.vue?vue&type=script&lang=js"
import style0 from "./VideoListItem.vue?vue&type=style&index=0&id=735c16b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c16b4",
  null
  
)

export default component.exports